import React from "react";
import {
  MDBCol,
  MDBRow,
  MDBContainer
} from 'mdb-react-ui-kit';

export default function Support() {

  const handleClick = () => {
    window.open("https://igl-group.com/", "_blank");
  };
  const handleClickAcorus = () => {
    window.open("https://okeiro.com/fr", "_blank");
  };
  const handleClickON = () => {
    window.open("https://www.objectif-numerique.fr/", "_blank");
  };

  return (
    <MDBContainer fluid style={{ backgroundColor: "rgb(33, 46, 79)" }} >
      <div style={{ textAlign: "center", backgroundColor: "rgb(33, 46, 79)", paddingTop: "20px" }}>
        <div style={{ width: '90%', marginLeft: "5%", height: '2px', backgroundColor: '#4A9E47' }}></div>
        <h2 style={{ marginBottom: "10px", marginTop: "10px", color: "#4A9E47", fontFamily: "Consolas, monospace" }}>Ils nous soutiennent</h2>
      </div>
    
      <MDBRow className="align-items-center">
        {/* Image à gauche */}
        <MDBCol md="2" className="text-center">
          {/* Conteneur pour l'image et l'overlay */}
          <div 
            style={{ 
              position: "relative", 
              display: "inline-block", 
              maxWidth: "400px", 
              width: "100%",
              cursor: "pointer" // Pour indiquer qu'il y a une interaction possible
            }}
          >
            {/* Image */}
            <img
              src="/Logo IGL (2).png"
              alt="IGL"
              style={{ width: "60%", marginLeft: "20%", display: "block" }}
              onClick={handleClick}
            />

          </div>
        </MDBCol>
         <MDBCol md="2" className="text-center">
          {/* Conteneur pour l'image et l'overlay */}
          <div 
            style={{ 
              position: "relative", 
              display: "inline-block", 
              maxWidth: "400px", 
              width: "100%",

              cursor: "pointer" // Pour indiquer qu'il y a une interaction possible
            }}
          >
            {/* Image */}
            <img
              src="/logo-full-dark@2x.png"
              alt="Okeiro"
              style={{ width: "70%", display: "block", margin: "0 auto", }}
              onClick={handleClickAcorus}
            />

          </div>
        </MDBCol>
         <MDBCol md="2" className="text-center">
          {/* Conteneur pour l'image et l'overlay */}
          <div 
            style={{ 
              position: "relative", 
              display: "inline-block", 
              maxWidth: "400px", 
              width: "100%",

              cursor: "pointer" // Pour indiquer qu'il y a une interaction possible
            }}
          >
            {/* Image */}
            <img
              src="/obj_num_logo-removebg-preview.png"
              alt="Objectif-Numérique"
              style={{ width: "70%", display: "block", margin: "0 auto", }}
              onClick={handleClickON}
            />

          </div>
        </MDBCol>
        <MDBCol md="6">
          <div id='programme' style={{
                  display: 'flex', // Utilise flexbox pour aligner horizontalement
                  alignItems: 'center', // Centre verticalement le contenu
                  gap: '10%', // Espacement entre la barre et le texte
                  minHeight: '200px',  // Assure-toi que le parent a une hauteur
                  scrollMarginTop: '120px',
                  padding: '5%',
                }}>

            <div>
              <p style={{ fontFamily: "Consolas, monospace", fontSize: "16px", lineHeight: "1.5", color: "#ffffff" }}>
                Et si vous nous rejoigniez ?
              </p>
              <ul style={{ fontFamily: "Consolas, monospace", fontSize: "14px", lineHeight: "1.2", color: "#ffffff" }}>
                <li>Affichez vos logos et vos couleurs dans nos voiles aux côtés du ruban vert, symbole de votre engagement dans un défis d'exception et pour la sensibilisation au don d'organes</li>
                <li>Venez naviguer sur nos bateaux avec vos équipes en séminaire</li>
                <li>Venez suivre un départ de course depuis un bateau accompagnateur </li>
                <li>Des conférences dans vos locaux ou dans nos écoles pour vos enjeux de recrutement</li>
              </ul>
              <p style={{ fontFamily: "Consolas, monospace", fontSize: "14px", lineHeight: "1.2", color: "#ffffff" }}>
                La course au large est une formidable opportunité pour fédérer vos collaborateurs autour d'une aventure riche en émotions fortes, pour renforcer votre image de marque et attirer de nouveaux talents.
              </p>
            </div>
          </div>
          </MDBCol>



      </MDBRow>


    </MDBContainer>
    
      
  );
}